import { render, staticRenderFns } from "./addCollection.vue?vue&type=template&id=47bb7dc7&scoped=true"
import script from "./addCollection.vue?vue&type=script&lang=js"
export * from "./addCollection.vue?vue&type=script&lang=js"
import style0 from "./addCollection.vue?vue&type=style&index=0&id=47bb7dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb7dc7",
  null
  
)

export default component.exports